/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import React, { DetailedHTMLProps, HTMLAttributes, useRef } from "react";
import { IoMdClose } from "react-icons/io";
import IconBerserkerMail from "./Icon";
interface Props
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  value: string;
  handleChange: (vle: string) => void;
  placeholder: string;
}

const Container = styled.div`
  width: 100%;
  height: 40px;
  border: 1px solid #dddddd;
  border-radius: 5px;
  outline: none;
  font-size: 15px;
  color: #383838;
  position: relative;

  :focus-within {
    box-shadow: 0px 0px 6px #fb972e4d;
    border: 1px solid #fb972e;
  }

  transition: box-shadow 0.3s, border 0.3s;

  background-color: #ffffff;
`;

const SearchIcon = styled.div`
  position: absolute;
  top: 11px;
  left: 10px;
  cursor: default;
`;

const CloseIcon = styled.div`
  position: absolute;
  top: 8px;
  right: 10px;
  cursor: pointer;
  height: 22px;
  width: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;

  :hover {
    background-color: #22222217;
  }
`;

const Input = styled.input`
  width: calc(100% - 40px);
  height: 100%;
  padding: 10px;
  border: none;
  border-radius: 5px;
  outline: none;
  margin: 0px 20px;
  font-size: 15px;

  &::placeholder {
    letter-spacing: 0.16px;
    color: #979797;
  }
`;

export default function SearchInput(props: Props): JSX.Element {
  const { value, handleChange, placeholder } = props;
  const ref = useRef<HTMLInputElement | null>(null);

  return (
    <Container {...props}>
      <SearchIcon>
        <IconBerserkerMail
          name="search"
          width={16}
          height={16}
          color="#CCCCCC "
        />
      </SearchIcon>
      <Input
        ref={ref}
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        placeholder={placeholder}
      />
      {value !== "" && (
        <CloseIcon
          onClick={() => {
            handleChange("");
            if (ref.current) ref.current.focus();
          }}
        >
          <IoMdClose color="#777777" size={16} />
        </CloseIcon>
      )}
    </Container>
  );
}
